// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import { jwtDecode } from 'jwt-decode'; // Import jwtDecode as named export
import ProductUpdate from "@/views/ProductUpdate.vue";
import ProductReservation from "@/views/ProductReservation.vue";
import PageNewsletter from "@/views/PageNewsletter.vue";
import PageForms from "@/views/PageForms.vue";
import LoginPage from "@/views/LoginPage.vue";
import RegisterUser from "@/views/RegisterUser.vue";
import RentAcar from "@/views/RentAcar.vue";
import CateringPage from "@/views/CateringPage.vue";
import CursoPage from "@/views/CursoPage.vue";
import CourseraPage from "@/views/CourseraPage.vue";
import StandardWebsites from "@/views/StandardWebsites.vue";
import MerceariaPage from "@/views/MerceariaPage.vue";
import UtopiaUpdate from "@/views/UtopiaUpdate.vue";
import EventosPage from "@/views/EventosPage.vue";
import QuillEditor from "@/components/QuillEditor.vue";
import BlogPost from "@/components/BlogPost.vue";
import PostedBlogs from "@/components/PostedBlogs.vue";
import FurniturePost from "@/components/FurniturePost.vue";
import SettingPage from "@/views/SettingPage.vue";
import SubmissionPage from "@/views/SubmissionPage.vue";
import MediaList from "@/views/MediaList.vue";
import EventosMatapa from "@/views/EventosMatapa.vue";
import WebsiteEdit from "@/views/WebsiteEdit.vue";
import WebsiteGroup from "@/views/WebsiteGroup.vue";
import ReserveCar from "@/views/ReserveCar.vue";
import CourseCard from "@/views/CourseCard.vue";
import CourseDetails from "@/views/CourseDetails.vue";
import FestivalPage from "@/views/FestivalPage.vue";
import MobilePage from "@/views/products/PhoneProducts.vue";
import GraphicPage from "@/views/products/GraphicProducts.vue";




const routes = [
  {
    path: "/product-update",
    component: ProductUpdate,
    meta: { requiresAuth: true },
  },
  {
    path: "/grafica",
    component: GraphicPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/mobiles",
    component: MobilePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/media",
    component: MediaList,
    meta: { requiresAuth: true },
  },
  {
    path: "/mobilias",
    component: FurniturePost,
    meta: { requiresAuth: true },
  },
  {
    path: "/Posted-Blogs",
    component: PostedBlogs,
    meta: { requiresAuth: true },
  },
  {
    path: "/Blog-Post",
    component: BlogPost,
    meta: { requiresAuth: true },
  },
  {
    path: "/product-quill",
    component: QuillEditor,
    meta: { requiresAuth: true },
  },
  {
    path: "/eventos",
    component: EventosPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/festival",
    component: FestivalPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/product-reservation",
    component: ProductReservation,
    meta: { requiresAuth: true },
  },
  {
    path: "/cosmeticos",
    component: UtopiaUpdate,
    meta: { requiresAuth: true },
  },
  {
    path: "/page-newsletter",
    component: PageNewsletter,
    meta: { requiresAuth: true },
  },
  { path: "/page-forms", component: PageForms, meta: { requiresAuth: true } },
  { path: "/rent-a-car", component: RentAcar }, // Adicione a rota RentACar
  { path: "/catering", component: CateringPage },
  { path: "/curso", component:CursoPage },
  { path: "/standard-websites", component: StandardWebsites },
  { path: "/mercearia-page", component: MerceariaPage },
  { path: "/", component: LoginPage },
  { path: "/login", component: LoginPage },
  { path: "/register", component: RegisterUser },
  { path: "/setting", component:  SettingPage},
  { path: "/dashboard", component:  SubmissionPage},
  { path: "/matapa", component:  EventosMatapa},
  { path: "/websiteedit", component:  WebsiteEdit},
  { path: "/Websites", component:  WebsiteGroup},
  { path: "/reservas", component:  ReserveCar},
  { path: "/cursos", component:  CourseraPage},
  { path: "/cards", component: CourseCard },
  { path: "/details/:id", name: "CourseDetails", component: CourseDetails, props: true },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Function to check if the token is expired
function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token); // Use jwtDecode here
    const currentTime = Date.now() / 1000; // in seconds
    return decoded.exp < currentTime;
  } catch (e) {
    return true; // return true if token is invalid
  }
}

// Global navigation guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (token && !isTokenExpired(token)) {
      next(); // proceed if authenticated and token is valid
    } else {
      localStorage.removeItem("token"); // remove expired token
      localStorage.removeItem("user");   // clear user data
      next('/login'); // redirect to login if token expired or missing
    }
  } else {
    next(); // proceed if route does not require authentication
  }
});

export default router;